export const colors = {
  teal: '#00C9A7',
  tealDark: '#0A8A7A',
  navy: '#0C3540',
  ink: '#1a1a1a',
  slateDark: '#444',
  slate: '#555',
  slateLight: '#777',
  slateLighter: '#888',
  border: '#e0e0e0',
  borderLight: '#e8e8e8',
  bg: '#ffffff',
  bgAlt: '#f8f9fa',
  sage: '#6B8E7F',
  terracotta: '#C17A6C',
  error: '#ff6b6b',
};

export const fonts = {
  display: "'DM Serif Display',serif",
  body: "'DM Sans',sans-serif",
  mono: "'Space Mono',monospace",
};

export const gradients = {
  teal: `linear-gradient(135deg,${colors.teal},${colors.tealDark})`,
};
